<template>
    <div id="custom-repeat">
        <a-modal
            :visible="true"
            :cancelText="$t('calendar.cancel')"
            okText="$t('calendar.save')"
            centered
            @cancel="$emit('close')"
            :footer="null"
        >
            <div class="title">{{ $t("calendar.customRepeat") }}</div>
            <div class="recurrence">
                <div class="recurrence-label">{{ $t("calendar.recurrenceFrequency") }}</div>
                <input type="number" v-model="recurrenceNumber" class="input-number" />
                <a-select v-model="recurrenceDate" show-search style="width: 150px">
                    <a-select-option v-for="(repeatTime, index) of repeatTimes" :key="index" :value="repeatTime.value">
                        {{ repeatTime.label }}
                    </a-select-option>
                </a-select>
            </div>
            <div style="margin-bottom: 10px" v-if="recurrenceDate === 'weeks'">
                <div style="font-size: 14px">{{ $t("calendar.repeatDays") }}</div>
                <div style="display: flex">
                    <div
                        v-for="day in days"
                        @click="addRepeatDay(day)"
                        class="repeat-days"
                        :class="isSelected(day) ? 'active' : ''"
                    >
                        {{ day.label }}
                    </div>
                </div>
            </div>
            <div style="margin-bottom: 10px" v-if="recurrenceDate === 'months'">
                <a-select v-model="recurrenceMonth" show-search style="width: 50%">
                    <a-select-option
                        v-for="(repeatMonth, index) of repeatMonths"
                        :key="index"
                        :value="repeatMonth.value"
                    >
                        {{ repeatMonth.label }}
                    </a-select-option>
                </a-select>
            </div>
            <div>
                <div class="end-date-label">{{ $t("calendar.end") }}</div>
                <a-radio-group v-model:value="selectEndDateType" class="radio-btns">
                    <a-radio value="any" class="radio-btn">{{ $t("calendar.never") }}</a-radio>
                    <a-radio value="select" class="radio-btn">
                        <div style="margin-right: 10px">{{ $t("calendar.thisDate") }}</div>
                        <a-date-picker v-model:value="endDateSelect" :disabled="selectEndDateType !== 'select'" />
                    </a-radio>
                    <a-radio value="recurrence" class="radio-btn">
                        <div style="margin-right: 10px">{{ $t("calendar.recurrenceCount") }}</div>
                        <input
                            type="number"
                            v-model="endDateRecurrence"
                            class="input-number"
                            :disabled="selectEndDateType !== 'recurrence'"
                        />
                    </a-radio>
                </a-radio-group>
            </div>
            <div class="footer-btns">
                <span class="footer-btn" @click="$emit('close')">{{ $t("calendar.cancel") }}</span>
                <span class="footer-btn" @click="save()">{{ $t("calendar.save") }}</span>
            </div>
        </a-modal>
    </div>
</template>

<script>
import { mapGetters, mapState, mapMutations, mapActions } from "vuex";
import { log2 } from "../../../../utils/log2";
import moment from "moment";
import TaskTag from "./TaskTag.vue";
import ScheduleTag from "./ScheduleTag.vue";
import EventTag from "./EventTag.vue";
import { sendSocketMessage } from "../../../../utils/socketStream";

moment.locale("tr");
const log = log2("CustomRepeat");
export default {
    name: "CustomRepeat",
    components: {},
    props: {},
    data() {
        return {
            recurrenceNumber: 1,
            recurrenceDate: "days",
            recurrenceMonth: "1",
            days: [
                {
                    label: "P",
                    value: "1",
                },
                {
                    label: "S",
                    value: "2",
                },
                {
                    label: "Ç",
                    value: "3",
                },
                {
                    label: "P",
                    value: "4",
                },
                {
                    label: "C",
                    value: "5",
                },
                {
                    label: "C",
                    value: "6",
                },
                {
                    label: "P",
                    value: "0",
                },
            ],
            repeatMonths: [
                {
                    label: this.$t("calendar.everyMonth")`${moment().date()} ${this.$t("calendar.dayOf")}`,
                    value: "1",
                },
                {
                    label: this.$t("calendar.firstEveryMonth")`${moment().format("dddd")} ${this.$t("calendar.dayOf")}`,
                    value: "2",
                },
            ],
            repeatTimes: [
                {
                    label: this.$t("calendar.day"),
                    value: "days",
                },
                {
                    label: this.$t("calendar.week"),
                    value: "weeks",
                },
                {
                    label: this.$t("calendar.month"),
                    value: "months",
                },
                {
                    label: this.$t("billing.year"),
                    value: "years",
                },
            ],
            endDate: new Date(),
            repeatDays: [],
            selectEndDateType: "any",
            endDateSelect: "",
            endDateRecurrence: 1,
        };
    },
    computed: {
        ...mapState({
            users: (state) => state.user.users.data,
            site: (state) => state.site.site,
            user: (state) => state.auth.user,
        }),
        ...mapGetters({}),
    },
    methods: {
        ...mapActions({}),
        ...mapMutations({}),
        addRepeatDay(val) {
            if (this.repeatDays.includes(val.value)) {
                const result = this.repeatDays.filter((day) => day !== val.value);
                if (result.length > 0) this.repeatDays = result;
            } else this.repeatDays = [...this.repeatDays, val.value];
        },
        isSelected(val) {
            return this.repeatDays.includes(val.value);
        },
        save() {
            const data = {
                recurrenceNumber: this.recurrenceNumber,
                recurrenceDate: this.recurrenceDate,
                repeatDays: this.repeatDays,
                selectEndDateType: this.selectEndDateType,
                endDateSelect: this.endDateSelect,
                endDateRecurrence: this.endDateRecurrence,
                recurrenceMonth: this.recurrenceMonth,
            };
            this.$emit("save", data);
            console.log("save");
        },
    },
    async mounted() {},
    watch: {},
};
</script>

<style lang="scss">
span.ant-radio + * {
    display: flex;
    align-items: center;
}
</style>

<style lang="scss" scoped>
.title {
    width: fit-content;
    font-weight: 600;
    margin-bottom: 10px;
    font-size: 16px;
}

.recurrence {
    display: flex;
    align-items: center;
    height: max-content;
    margin-bottom: 10px;
}

.recurrence-label {
    font-size: 14px;
    margin-right: 5px;
}

.input-number {
    border: 0.5px solid grey;
    border-radius: 10px;
    height: 30px;
    width: 50px;
    margin-right: 10px;
}

.end-date-label {
    margin-bottom: 10px;
    font-size: 15px;
}

.end-date {
    display: flex;
    margin-bottom: 7px;
    align-items: center;
}

.end-date-radio-btn {
    width: 17px;
    margin-right: 10px;
}

.radio-btns {
    display: flex;
    flex-direction: column;
}

.radio-btn {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
}

.footer-btns {
    display: flex;
    justify-content: flex-end;
    margin-top: 10px;
}

.footer-btn {
    padding: 6px 10px;
    font-size: 13px;
    border-radius: 5px;
    margin-right: 10px;
    cursor: pointer;
    background-color: #107fc3;
    color: white;
}

.repeat-days {
    margin-right: 5px;
    padding: 3px;
    border-radius: 50%;
    width: 20px;
    height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 11px;
    cursor: pointer;
    background-color: #e6e6e6;
    color: grey;

    &.active {
        background-color: #107fc3;
        color: white;
    }
}

#custom-repeat {
    background-color: #ffffff;
    height: 100%;
}
</style>
